import { useState } from 'react';
import { FileText, Users } from 'lucide-react';
import FacturationTable from '../components/FacturationTable';
import PageHeader from '../components/PageHeader';
import TabNavigation from '../components/TabNavigation';

/**
 * Page Facturation - Gestion des factures émises
 * Structure de la page avec titre et sous-titre
 */
export default function FacturationPage() {
  const [activeTab, setActiveTab] = useState('externe');
  const [animating, setAnimating] = useState(null);

  const tabs = [
    {
      id: 'externe',
      label: 'GIE → Prestataires',
      icon: FileText
    },
    {
      id: 'interne',
      label: 'Consultants → GIE',
      icon: Users
    }
  ];

  const handleTabChange = (newTab) => {
    if (newTab === activeTab) return;
    const currentIndex = tabs.findIndex(t => t.id === activeTab);
    const newIndex = tabs.findIndex(t => t.id === newTab);
    setAnimating({ tab: newTab, dir: newIndex > currentIndex ? 'forward' : 'backward' });
    setActiveTab(newTab);
  };

  const slideAnim = (tabId) => {
    if (!animating || animating.tab !== tabId) return 'none';
    return animating.dir === 'forward' ? 'slideInLeft 0.3s ease-out' : 'slideInRight 0.3s ease-out';
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      fontFamily: '"Noto Sans", sans-serif'
    }}>
      <PageHeader
        icon={FileText}
        title="Facturation"
        subtitle="Gestion des factures émises"
      />

      <TabNavigation
        tabs={tabs}
        activeTab={activeTab}
        onTabChange={handleTabChange}
      />

      <div style={{ display: activeTab === 'externe' ? 'block' : 'none', animation: slideAnim('externe') }}>
        <FacturationTable initialTab="externe" />
      </div>
      <div style={{ display: activeTab === 'interne' ? 'block' : 'none', animation: slideAnim('interne') }}>
        <FacturationTable initialTab="interne" />
      </div>

      <style>{`
        @keyframes slideInLeft {
          from { transform: translateX(100%); opacity: 0; }
          to   { transform: translateX(0);    opacity: 1; }
        }
        @keyframes slideInRight {
          from { transform: translateX(-100%); opacity: 0; }
          to   { transform: translateX(0);     opacity: 1; }
        }
      `}</style>
    </div>
  );
}
